export class CartCookie {
    public static WriteBTCCartCookie(BTCCartCookieName: string, CartCookieJsonString: string, BTCCookeCartLifeDays: number): void {
        const date = new Date();
        date.setTime(date.getTime() + (BTCCookeCartLifeDays * 24 * 60 * 60 * 1000)); // Figure expiration date of 7 days

        // Note: The format of this cookie must match how the BTC API expects the cookies (json, uri encoded)
        document.cookie = BTCCartCookieName + "=" + encodeURIComponent(CartCookieJsonString)
            + "; expires=" + date.toUTCString() +
            "; path=/; Secure; IsEssential; SameSite=Strict";
    }

    public static GetBTCCartCookieAsJsonString(BTCCartCookieName: string): string | null {
        const cookie = document.cookie.split(';').find(c => c.indexOf(BTCCartCookieName + "=") === 0);
        if (cookie) // Found cart cookie?
        {
            const sRawCookieValue = cookie.substring(BTCCartCookieName.length + 1, cookie.length);
            const decoded = decodeURIComponent(sRawCookieValue);
            return decoded;
        }
        return null;
    }

    // This function should only be called from Blazor. If it's called from javascript, then the Blazor page
    // won't see the cookie changes and will write the deleted cookies back to the browser.
    public static DeleteBTCCartCookie(BTCCartCookieName: string,): void {
        document.cookie = BTCCartCookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'; // https://www.w3schools.com/js/js_cookies.asp
    }
}
